export const iconDictionary = {
    "Transportation & Infrastructure": "bi-bus-front-fill",
    "Housing Program": "bi-house-door-fill",
    "Parks & Recreation": "bi-tree-fill",
    Other: "bi-bookmark-fill",
    Water: "bi-droplet-fill",
    "Building Construction": "bi-hammer",
  };

  